import React from 'react';

const DiagonalServicesSlider = () => {
  const services = [
    'Custom Embroidery Digitizing',
    'Logo Digitizing',
    'Cap / Hat Digitizing',
    '3D Puff Embroidery',
    'Flat Embroidery',
    'Left Chest Logo',
    'Jacket Back Digitizing',
    'Sleeve Logo Digitizing',
    'Applique Digitizing',
    'Chenille Embroidery',
    'Patch Digitizing',
    'Badge Digitizing',
    'Monogram Digitizing',
    'Vector Art & DTF'
  ];

  return (
    <section className="diagonal-services-slider">
      {/* First Stripe - Left to Right */}
      <div className="diagonal-stripe stripe-1">
        <div className="stripe-content stripe-content-ltr">
          {/* Repeat services 3 times for seamless loop */}
          {[...services, ...services, ...services].map((service, index) => (
            <span key={index} className="service-text">{service}</span>
          ))}
        </div>
      </div>

      {/* Second Stripe - Right to Left */}
      <div className="diagonal-stripe stripe-2">
        <div className="stripe-content stripe-content-rtl">
          {/* Repeat services 3 times for seamless loop */}
          {[...services, ...services, ...services].map((service, index) => (
            <span key={index} className="service-text">{service}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DiagonalServicesSlider;